import { Controller } from "@hotwired/stimulus";

// this is used to watch for elements tagged with data-watcher-target="watch"
// and dispatch events when they enter or exit the dom
export default class extends Controller {
  static targets = ["watch"];
  static values = { event: String };

  watchTargetConnected(target) {
    let event = target.dataset.event;
    if (event === "" || event === null || event === undefined) {
      event = this.eventValue;
    }
    this.dispatch(`${event}:entered`);
  }

  watchTargetDisconnected(target) {
    let event = target.dataset.event;
    if (event === "" || event === null || event === undefined) {
      event = this.eventValue;
    }
    this.dispatch(`${event}:exited`);
  }
}
